module.exports = __webpack_public_path__ + "img/Day-Off.a357e60e.svg";